import { render, staticRenderFns } from "./VServiceSelector.vue?vue&type=template&id=f44ddf90"
import script from "./VServiceSelector.vue?vue&type=script&lang=js"
export * from "./VServiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports